interface AmountInputProps {
  amountNAU: number; // Current NAU amount
  onAmountChange: (value: number) => void; // Handler for value updates
  loading: boolean; // Disable input while loading
  remainingBalance: number; // Balance left to enforce limits
}

const AmountInput: React.FC<AmountInputProps> = ({
  amountNAU,
  onAmountChange,
  loading,
  remainingBalance,
}) => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-20 w-full">
      {/* Quick-add buttons for +1K, +10K, +100K */}
      <div className="flex flex-row md:flex-col gap-2">
        {[1000, 10000, 100000].map((increment) => (
          <button
            key={increment}
            disabled={remainingBalance < increment}
            className={`py-1.5 px-3 text-white text-xs font-bold transition-transform duration-200 ${
              remainingBalance < increment
                ? "bg-gray-500 cursor-not-allowed opacity-50"
                : "bg-[var(--color-primary)] hover:bg-[var(--color-primary-light)] hover:scale-105 active:scale-95"
            }`}
            onClick={() => onAmountChange(amountNAU + increment)}
          >
            +{increment / 1000}K
          </button>
        ))}
      </div>

      {/* Numeric input field for direct amount entry */}
      <input
        type="number"
        value={amountNAU}
        onChange={(e) => onAmountChange(Math.max(0, Number(e.target.value)))}
        placeholder="Enter amount"
        disabled={loading}
        className="w-32 md:w-24 p-1.5 text-xs border-2 border-gray-300 transition-transform duration-200 focus:outline-none focus:shadow-lg focus:scale-105 text-center"
      />

      {/* Quick-decrement buttons for -1K, -10K, -100K */}
      <div className="flex flex-row md:flex-col gap-2">
        {[1000, 10000, 100000].map((decrement) => (
          <button
            key={decrement}
            disabled={amountNAU <= 0}
            className={`py-1.5 px-3 text-white text-xs font-bold transition-transform duration-200 ${
              amountNAU <= 0
                ? "bg-gray-500 cursor-not-allowed opacity-50"
                : "bg-[var(--color-secondary)] hover:bg-[var(--color-primary-light)] hover:scale-105 active:scale-95"
            }`}
            onClick={() => onAmountChange(Math.max(0, amountNAU - decrement))}
          >
            -{decrement / 1000}K
          </button>
        ))}
      </div>
    </div>
  );
};

export default AmountInput;
